export default "__VITE_ASSET__32de5186__"